import { render } from "./NosotrosSection.vue?vue&type=template&id=8edc7c3c&scoped=true"
import script from "./NosotrosSection.vue?vue&type=script&lang=js"
export * from "./NosotrosSection.vue?vue&type=script&lang=js"

import "./NosotrosSection.vue?vue&type=style&index=0&id=8edc7c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8edc7c3c"]])

export default __exports__